import { Component, Input } from '@angular/core';

@Component({
	selector: 'c-art-html',
	templateUrl:'art-html.component.html'
})

export class ArtHtmlComp{
	@Input() articulo : any = false;
	constructor(){}
}